<div class="container-fluid">
    <h2 class="mb-3" mat-dialog-title>Add Course</h2>
    <mat-dialog-content>
        <div class="row mb-4">
            <google-autocomplete (setAddress)="getEstablishment($event)" adressType="establishment" />
            <mat-error *ngIf="showError" [innerHTML]="error"></mat-error>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button (click)="onSave()">Save</button>
        <button mat-raised-button color="warn" (click)="diaglogRef.close('cancel')">Cancel</button>
    </mat-dialog-actions>
</div>